import {
  FakeFormControl,
  SpecialValidatorFnFactory,
} from '@app/shared/utils/special-validators/special-validators.model';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DuplicateStringOptions } from '@app/shared/forms/dynamic-form/fields.service';
import { SpecialValidationType } from '@app/origami-api/constants/validation-type';

export const duplicateStringValidator: SpecialValidatorFnFactory = function (options: DuplicateStringOptions) {
  return function (control: AbstractControl | FakeFormControl): ValidationErrors | null {
    if (!control.value || !options.currentName) {
      return null;
    }
    const isDuplicate = options.currentName.trim() === control.value.trim();
    return isDuplicate ? { [SpecialValidationType.DuplicateString]: { value: control.value } } : null;
  };
};
